import ContactForm from './ContactForm';
import './Contact.css';
import { Helmet } from 'react-helmet';

function Contact() {

  return (
    <div className="Contact-form-page">
      <Helmet>
        <title>Contact Page</title>
        <meta name="description" content="To contact Aethel, fill out her contact form and she will respond via email." />

        {/* Page-Specific Open Graph Tags */}
        <meta property="og:title" content="Contact Page - Aethel Music" />
        <meta property="og:description" content="To contact Aethel, fill out her contact form and she will respond via email." />
        <meta property="og:image" content="%PUBLIC_URL%/images/BiopicMedium.png"  />
        <meta property="og:url" content="https://aethel.vercel.app/contact" />

        {/* Page-Specific Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Page - Aethel Music" />
        <meta name="twitter:description" content="To contact Aethel, fill out her contact form and she will respond via email." />
        <meta name="twitter:image" content="%PUBLIC_URL%/images/BiopicMedium.png"  />
      </Helmet>
      <h1>Contact</h1>
      <div className='contact-content'>
        <p>Æthel is available for both performance and bespoke songcrafting.</p>
        <p>She also has material that could be used for sync licensing.</p>
        <p>If you would like to contact Æthel for any of these reasons,
          please enter your details below and she will contact you to communicate further.</p></div>
      <ContactForm />
    </div>
  );
}

export default Contact;

